module.exports = __webpack_public_path__ + "static/year_portrait_with_list-73407b45c44d2a9e8fbf9e5c050fb7b9.png";